import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./Member.css";
import Navbar from "./Navbar";
import Agenttable from "./Agenttable.jsx";
import Header from "./header";
import { useLocation } from "react-router-dom";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useLanguage } from "../../common/i18n/LanguageContext";

function Agent() {
  const { t } = useLanguage();
  const [level, Setlevel] = useState("Loading");
  const location = useLocation();
  const pos = localStorage.getItem("position");

  const searchParams = new URLSearchParams(location.search);
  const levelurl = searchParams.get("level");
  const username = searchParams.get("username");
  const user = localStorage.getItem("user");
  const positions =
    levelurl === "senior"
      ? "Owner"
      : levelurl === "master"
        ? "Senior"
        : levelurl === "agent"
          ? "Master"
          : "Agent";
  const headerTitle = positions + ` (${username ?? user})`;

  useEffect(() => {
    Setlevel(levelurl);
    // eslint-disable-next-line
  }, [location]);

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={`${headerTitle ?? ""}`} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <a
              href={`/agentadd?level=${level}${username ? `&uplineusername=${username}` : ""}`}
              className="text-white no-underline"
            >
              <div className="p-1 mb-1 bg-gradient-to-b from-brand-gold-300 via-brand-gold-400 to-brand-gold-600 h-[2em] w-auto inline-flex items-center text-brand-ink-onGold rounded border border-brand-gold-200 shadow-gold hover:brightness-105">
                <GroupAddIcon sx={{ fontSize: 16 }} className="ml-1" />
                <span className="ml-1 text-xs font-bold">
                  {t("common_add")}{" "}
                  {level === "master"
                    ? "Master"
                    : level === "senior"
                      ? "Senior"
                      : "Agent"}
                </span>
              </div>
            </a>
            <Agenttable poslevel={level} username={username} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Agent;
